import React from 'react';
import Button from '@components/dataEntry/button/Button';
import {
  ITEM_FUNCTION_TPYE,
  ITEM_FUNCTION_TPYE_VALUE,
  PET_SUB_FUNCTION_TYPE,
  PET_SUB_FUNCTION_TYPE_VALUE,
} from '@typings/store/storeItemFunctionType';

export type InventoryActionContext = {
  photocardID?: string;
  itemId?: string;
  data?: any;
  currentUid?: string | null;
};

type Handlers = {
  onUseStatus: (ctx?: InventoryActionContext) => void;
  onAddMyroom: (ctx?: InventoryActionContext) => void;
  onOpenBettingDemo: (ctx?: InventoryActionContext) => void;
  onOpenQuestCreate: (ctx?: InventoryActionContext) => void;
  onOpenUserGift: (ctx?: InventoryActionContext) => void;
  onOpenChangeName: (ctx?: InventoryActionContext) => void;
  onOpenChangeAppearance: (ctx?: InventoryActionContext) => void;
  onOpenChangeBackground: (ctx?: InventoryActionContext) => void;
  onUseRandomBox: (ctx?: InventoryActionContext) => void;
  onUseBagExpand: (ctx?: InventoryActionContext) => void;
};

export function drawPetActionBySubType(
  subType?: PET_SUB_FUNCTION_TYPE_VALUE,
  h?: Handlers,
  ctx?: InventoryActionContext,
) {
  const map: Partial<Record<PET_SUB_FUNCTION_TYPE_VALUE, JSX.Element>> = {
    [PET_SUB_FUNCTION_TYPE.FILL_HUNGER]: <></>,
    [PET_SUB_FUNCTION_TYPE.FILL_EXP]: <></>,
    [PET_SUB_FUNCTION_TYPE.CHANGE_NAME]: (
      <Button onClick={() => h?.onOpenChangeName?.(ctx)}>사용하기</Button>
    ),
    [PET_SUB_FUNCTION_TYPE.CHANGE_APPEARANCE]: (
      <Button onClick={() => h?.onOpenChangeAppearance?.(ctx)}>사용하기</Button>
    ),
    [PET_SUB_FUNCTION_TYPE.CHANGE_BACKGROUND]: (
      <Button onClick={() => h?.onOpenChangeBackground?.(ctx)}>사용하기</Button>
    ),
  };
  return subType ? map[subType] ?? null : null;
}

export default function inventoryActionMap(
  ft?: ITEM_FUNCTION_TPYE_VALUE,
  subType?: PET_SUB_FUNCTION_TYPE_VALUE,
  h?: Handlers,
  ctx?: InventoryActionContext,
  disabled?: boolean,
) {
  const map: Partial<Record<ITEM_FUNCTION_TPYE_VALUE, JSX.Element>> = {
    [ITEM_FUNCTION_TPYE.STATUS]: (
      <Button onClick={() => h?.onUseStatus?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
    [ITEM_FUNCTION_TPYE.MYROOM]: (
      <Button onClick={() => h?.onAddMyroom?.(ctx)} disabled={disabled}>마이룸 추가</Button>
    ),
    [ITEM_FUNCTION_TPYE.BETTING_CREATE]: (
      <Button onClick={() => h?.onOpenBettingDemo?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
    [ITEM_FUNCTION_TPYE.QUEST_CREATE]: (
      <Button onClick={() => h?.onOpenQuestCreate?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
    [ITEM_FUNCTION_TPYE.USERGIFT]: (
      <Button onClick={() => h?.onOpenUserGift?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
    [ITEM_FUNCTION_TPYE.PET]: drawPetActionBySubType(subType, h, ctx) ?? <></>,
    [ITEM_FUNCTION_TPYE.EQUIPMENT]: (
      <Button onClick={() => h?.onUseStatus?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
    [ITEM_FUNCTION_TPYE.SKILL]: (
      <Button onClick={() => h?.onUseStatus?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
    [ITEM_FUNCTION_TPYE.RANDOM_BOX]: (
      <Button onClick={() => h?.onUseRandomBox?.(ctx)} disabled={disabled}>뽑기 오픈</Button>
    ),
    [ITEM_FUNCTION_TPYE.BAG_EXPAND]: (
      <Button onClick={() => h?.onUseBagExpand?.(ctx)} disabled={disabled}>사용하기</Button>
    ),
  };
  return ft ? map[ft] ?? null : null;
}
